type FormDataValue = string | number | boolean | File | Blob | null | undefined;

export function buildFormData(fields: Record<string, FormDataValue>): FormData {
  const data = new FormData();

  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value instanceof Blob) {
      data.append(key, value);
      return;
    }
    data.append(key, String(value));
  });

  return data;
}
